import React from 'react'
import { useDispatch } from 'react-redux'

import { useMsal } from '@azure/msal-react'
import { Capacitor } from '@capacitor/core'
import { useQueryClient } from '@tanstack/react-query'
import { signOut } from 'store/modules/auth/actions'

import DesktopView from './Desktop.view'
import MobileView from './Mobile.view'

function SignOut() {
  const { instance, accounts } = useMsal()
  const dispatch = useDispatch()
  const queryClient = useQueryClient()
  function handleSignOut() {
    if (accounts.length) {
      instance.logoutRedirect({
        onRedirectNavigate: () => false,
      })
    }
    queryClient.clear()
    dispatch(signOut())
    localStorage.setItem('dateConfig', null)
  }

  if (Capacitor.isNativePlatform() || window._env_?.CAPACITOR_DEBUG) {
    return <MobileView handleSignOut={handleSignOut} />
  }

  return <DesktopView handleSignOut={handleSignOut} />
}

export default SignOut
